/**
 * v8.12 — Tracking de visualização do cardápio (/delivery).
 * 1 hit por visitante a cada 30 min: throttle client-side (localStorage) +
 * dedup server-side por sessionId. Fire-and-forget: nunca bloqueia a página.
 */
const API = process.env.REACT_APP_BACKEND_URL || '';
const THROTTLE_MS = 30 * 60 * 1000;

export function trackMenuView() {
  try {
    if (!API) return;
    let sid = localStorage.getItem('kaven_visitor_id');
    if (!sid) {
      sid = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem('kaven_visitor_id', sid);
    }
    const last = Number(localStorage.getItem('kaven_menu_view_at') || 0);
    if (Date.now() - last < THROTTLE_MS) return;
    localStorage.setItem('kaven_menu_view_at', String(Date.now()));
    fetch(`${API}/api/menu-views/hit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sid }),
    }).catch(() => {});
  } catch {/* tracking nunca quebra o cardápio */}
}

export async function fetchMenuViewStats(startIso) {
  const resp = await fetch(`${API}/api/menu-views/stats?start=${encodeURIComponent(startIso)}`);
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}
